export const isStringPositiveNumber = (numberString: string) => {
  const number = parseFloat(numberString);
  return isPositiveFiniteNumber(number) && String(number) === numberString;
};

export const isPositiveFiniteNumber = (number: number) => {
  return isFinite(number) && number > 0;
};
